import React from 'react'
import { Typography, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, Slide, Button } from '@material-ui/core'
import { TransitionProps } from '@material-ui/core/transitions'

const Transition = React.forwardRef(function Transition(props: TransitionProps & { children?: React.ReactElement<any, any> },ref: React.Ref<unknown>,) { 
    return <Slide direction="up" ref={ref} {...props} />
})

type ConfirmDialogPropsType = {
    open: boolean,
    confirm?: (context?: any) => void,
    cancel?: (event: {}) => void,
    onClose?: (event: {}, reason: "backdropClick" | "escapeKeyDown") => void,
    title?: string,
    prompt?: string,
    confirmText?: string,
    cancelText?: string,
    context?: any,
    children?: React.ReactNode,
    onEnter?: () => void,
}
const ConfirmDialog = (props: ConfirmDialogPropsType) => {
    const handleOnClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if(reason === 'escapeKeyDown' && props.cancel) {
            props.cancel(event)
        }
    }
    return (
        <Dialog open={props.open} onClose={props.onClose ? props.onClose : handleOnClose} 
            TransitionComponent={Transition} keepMounted style={{zIndex: 2000}}
            onEnter={props.onEnter}
        >
			<DialogTitle>
				{props.title ? props.title : 'Eliminazione elemento'}
			</DialogTitle>

			<DialogContent>

                {props.children 
                ? props.children 
                : (
                    <DialogContentText gutterBottom>
                        Procedo con la cancellazione
                    </DialogContentText>
                )}
				<Typography variant='caption'>
					<b>{props.prompt ? props.prompt : "Cancello l'elemento?"}</b>
				</Typography>
			</DialogContent>

			<DialogActions>
                {props.confirm && 
                    <Button onClick={(event) => props.confirm && props.confirm(props.context)} variant="contained" color="primary" size='small'>
                        {props.confirmText ? props.confirmText : 'SI'}
                    </Button>
                }
                {props.cancel && 
                    <Button onClick={props.cancel} variant="contained" color="default" size='small'>
                        {props.cancelText ? props.cancelText : 'NO'}
                    </Button>
                }
			</DialogActions>
		</Dialog>
    )
}

export default ConfirmDialog